module.exports = __webpack_public_path__ + "img/logo_old.ede95eb3.svg";